import PageHeader from "components/PageHeader";
import { Template } from "layouts/Template";
import React from "react";
import { useSelector } from "react-redux";
import { useGetElevesByParentQuery } from "redux_dir/features/eleveApi";
import { useCreateCheckoutMutation } from "redux_dir/features/paiementApi";
import { getParentForm } from "redux_dir/features/parentSlice";
import { ArrowRight } from "tabler-icons-react";
import Analytics from "utils/analytics";

// Politique tarifaire selon le nombre d'enfants (FCFA)
const PRICE_ONE_CHILD = 3500;
const PRICE_TWO_CHILDREN = 4000;
const PRICE_THREE_CHILDREN_AND_MORE = 5000;

export const getPaymentAmount = (childrenCount) => {
  if (childrenCount >= 3) return PRICE_THREE_CHILDREN_AND_MORE;
  if (childrenCount === 2) return PRICE_TWO_CHILDREN;
  return PRICE_ONE_CHILD;
};

function PayementPage() {
  const parent = useSelector(getParentForm);
  const { data: elevesData, isLoading: elevesLoading } =
    useGetElevesByParentQuery({ parentId: parent?.id }, { skip: !parent?.id });
  const amount = getPaymentAmount(elevesData?.data?.length ?? 1);
  const [createCheckout, { isLoading: waveLoading }] =
    useCreateCheckoutMutation();

  const paymentReturnBaseUrl =
    process.env.REACT_APP_PAYMENT_RETURN_URL ||
    (window.location.protocol === "https:"
      ? window.location.origin
      : "https://parent.genimi.io");

  const handlePayWave = async () => {
    try {
      Analytics.trackValiderButton("Payment Page", "Payment");

      // Déterminer l'URL de base de l'API
      const apiBaseUrl =
        process.env.REACT_APP_BASE_API_URL?.replace("/api/v1/", "") ||
        "https://backend.genimi.io";

      const checkoutData = {
        amount: amount.toString(),
        currency: "XOF",
        error_url: `${paymentReturnBaseUrl}/payment/error`,
        success_url: `${paymentReturnBaseUrl}/`,
        client_reference: parent?.id?.toString() || "0",
        webhook_url: `${apiBaseUrl}/aapi/wave/checkout/webhook`, // URL du webhook
      };

      console.log("📤 Données envoyées à Wave:", checkoutData);

      const response = await createCheckout(checkoutData).unwrap();

      console.log("📥 Réponse de Wave:", response);

      // La réponse peut être soit une chaîne JSON
      let data;
      if (typeof response === "string") {
        data = JSON.parse(response);
      } else {
        data = response;
      }

      if (data.wave_launch_url) {
        // Rediriger  vers la page de paiement Wave
        window.location.href = data.wave_launch_url;
      } else if (data.code === "request-validation-error") {
        // Erreur de validation Wave
        const errorDetails =
          data.details?.map((d) => d.msg).join(", ") || data.message;
        throw new Error(`Erreur Wave: ${errorDetails}`);
      } else {
        throw new Error("URL de paiement non reçue");
      }
    } catch (error) {
      console.error("Erreur paiement:", error);
      Analytics.trackError("Payment Error", error.message, "Payment Page");
      alert(`Erreur: ${error.message || "Erreur inconnue"}`);
    }
  };

  return (
    <Template
      header={<PageHeader title={"Paiement"} />}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 20,
        padding: 10,
      }}
    >
      <div className="flex justify-center">
        <img
          src={"https://www.wave.com/img/nav-logo.png"}
          height={45}
          alt="wave"
        />
      </div>

      {/* Montant fixe */}
      <div className="mx-3">
        <label className="block text-sm font-medium mb-2">
          Montant à payer
        </label>
        <div className="w-full p-4 border border-gray-300 rounded-lg flex items-center justify-between bg-gray-50">
          <span className="text-2xl font-bold text-gray-800">
            {amount} FCFA
          </span>
        </div>
        <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            💰 Vous recevrez : <span className="font-bold">3000 crédits</span>
          </p>
        </div>
      </div>

      <button
        className="flex items-center justify-center cursor-pointer gap-5 text-white p-3 my-4 bg-[#1AB3E5] rounded-full mx-3 disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="cypress-welcom-button"
        onClick={handlePayWave}
        disabled={waveLoading || elevesLoading}
      >
        {waveLoading
          ? "Chargement..."
          : `Valider le paiement de ${amount} FCFA`}
        {!waveLoading && <ArrowRight color="#fff" />}
      </button>
    </Template>
  );
}

export default PayementPage;
